export default __webpack_public_path__ + "static/X01-b28569a14a6952b57ccfef9cd9dab62d.png";